<div class="app-popup">
   <div class="app-popup-content text-center">
      <div class="mb-4">
         <h4>Are you sure you want to delete this product?</h4>
      </div>
      <button mat-raised-button color="accent" class="mr-3" (click)="dialogRef.close('yes')">Yes</button>
      <button mat-raised-button color="accent" class="mr-3" (click)="dialogRef.close()">No</button>
   </div>
</div>